(ns frontend.view.entity-viewers.modules.guests
  (:require
   [frontend.state.current-session :as session]
   [frontend.view.components.form.person-to-guest.person-account-card :as person-account-card]
   [reagent.core :as r]
   [frontend.logging :as logging]
   [common.localization :as loc]
   [common.util :as cu]
   [potpuri.core :as p :refer [fn-> fn->>]]
   [frontend.actions.account :as account-actions]
   [frontend.actions.guest :as guest-actions]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.guest-invite.view :as guest-invite]
   [ui.components.button.view :as button]))

(defn remove-guest!
  [show-notification! show-error! role-entity]
  (let [data {:role-id (:db/id role-entity)}
        on-success! (fn [_]
                      (when show-notification!
                        (show-notification! (loc/tr :guest-removed-successfully)))
                      (logging/log "Removed guest!"))
        on-error! (fn [e]
                    (when show-error!
                      (show-error! (loc/tr :guest-removal-failed)))
                    (logging/error "error: removing guest!" e))]
    (guest-actions/*->revoke! data
                              on-success!
                              on-error!)))

(defn invite-guest!
  [show-notification! show-error! target-id person email role]
  (let [{:keys [person/first-name person/last-name]} person
        data {:target-id target-id
              :person-id (:db/id person)
              :account   (merge {:account/email email}
                                (if first-name
                                  {:account/first-name first-name})
                                (if last-name
                                  {:account/last-name last-name}))
              :role      role}
        on-success! (fn [_]
                      (when show-notification!
                        (show-notification! (loc/tr :invitation-sent-successfully)))
                      (logging/log "Invited guest!"))
        on-error! (fn [e]
                    (when show-error!
                      (show-error! (loc/tr :invitation-failed)))
                    (logging/error "error: inviting guest!" e))]
    (account-actions/*->invite-guest data on-success! on-error!)))

(defn re-invite-guest!
  [show-notification! show-error! target-id email guest-role]
  (let [role-id (:db/id guest-role)
        data {:target-id target-id
              :role-id   role-id}
        on-success! (fn [_]
                      (when show-notification!
                        (show-notification! (loc/tr :invitation-sent-successfully)))
                      (logging/log "Re-invited guest!"))
        on-error! (fn [e]
                    (when show-error!
                      (show-error! (loc/tr :invitation-failed)))
                    (logging/error "error: reinviting guest!" e))]
    (account-actions/*->re-invite-guest data on-success! on-error!)))


(defn render-module
  [local-atom
   {:keys [entity-atom entity-id fields guest-roles
           show-error! show-notification!]
    :as   args}]
  (let [re-invite-guest! (r/partial re-invite-guest! show-notification! show-error! entity-id)
        remove-guest! (r/partial remove-guest! show-notification! show-error!)
        role-attribute (:attribute (first fields))]

    [:div
     {:class "mb-0 mt-2 px-2 text-sm"}
     (when (= :role/guest-buy-side role-attribute)
       [:div
        {:class "flex flex-col gap-2"}
        [:h3
         {:class "pt-2 font-bold"}
         (loc/tr :note!)]
        [:p
         "Guest users you invite to this deal can only see information related to this specific deal. These guests might include advisors, venture partners,
         heads of business units or anyone else from your buy-side transaction team."]
        [:p
         "If you want to grant someone access to multiple deals, you can do that by inviting them to each of the deals separately."]
        [:p
         "The guest users you invite here will have user rights similar to people in your core team, with these exceptions:"]
        [:h3
         {:class "pt-2 font-bold"}
         "Guest users"]
        [:ul
         [:li "Cannot access the deal toolbar (pass, put on hold, etc)"]
         [:li "Cannot see or edit the deal owner"]
         [:li "Cannot see or edit the deal rating"]
         [:li "Cannot edit the deal name"]
         [:li "Cannot see or edit the deal stage"]
         [:li "Cannot see or edit associated deals, people, companies, commitments or holdings"]
         [:li "Cannot pair their email account with your Zapflow account"]
         [:li "Cannot send emails from Zapflow"]
         [:li
          [:span.underline "Can"]
          " see basic company information but can not navigate to the full company view"]
        ]])
     (doall
      (for [{:keys [attribute label]} fields
            :let [roles (->> guest-roles
                             (cu/only-entity :role/role attribute))]]
        ^{:key (str "guests-attribute-" attribute)}
        [:div
         {:class "py-2 flex flex-col gap-2 justify-start items-start"}
         [:label
          {:class "block pt-2 font-semibold"}
          label]
         [:div
          {:class "flex flex-col gap-2 w-full"}
          (doall
           (for [guest-role roles
                 :let [account-id (:role/subject guest-role)
                       account @(r/track session/get-entity account-id)
                       email (:account/email account)]]
             ^{:key (str "guest--" entity-id (:db/id guest-role))}
             [person-account-card/invited-person
              {:associated-account account
               :target           @entity-atom
               :re-invite-guest! (r/partial re-invite-guest! email guest-role)
               :remove-guest!    (r/partial remove-guest! guest-role)}]))]
         (when-not (session/is-read-only-user?)
           [button/primary-open
            {:on-click   (fn []
                           (modals/open-modal! guest-invite/modal-key
                                               {:target-id  entity-id
                                                :guest-role role-attribute}))}
            [:span (loc/tr :add)]])]))]))

(defn view
  [{:keys [:entity-id]}]
  (let [local-atom (r/atom {})
        entity-atom (r/cursor session/entities [entity-id])]
    (fn [args]
      [render-module local-atom
       (merge args
              {:entity-atom entity-atom})])))
